// src/redux/searchHistorySlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchSearchHistory as fetchSearchHistoryService } from "../services/searchHistoryService";

const toErrorMessage = (err, fallback) => {
  if (!err) return fallback;
  if (typeof err === "string") return err;
  return err?.message || fallback;
};

export const fetchSearchHistoryAsync = createAsyncThunk(
  "searchHistory/fetch",
  async (userId, { rejectWithValue }) => {
    try {
      const data = await fetchSearchHistoryService(userId);
      return Array.isArray(data) ? data : [];
    } catch (error) {
      return rejectWithValue(toErrorMessage(error, "Failed to load search history."));
    }
  }
);

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const searchHistorySlice = createSlice({
  name: "searchHistory",
  initialState,
  reducers: {
    clearSearchHistory(state) {
      state.items = [];
      state.error = null;
      state.loading = false;
    },
    clearSearchHistoryError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSearchHistoryAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSearchHistoryAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload || [];
      })
      .addCase(fetchSearchHistoryAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to load search history.";
      });
  },
});

export const { clearSearchHistory, clearSearchHistoryError } = searchHistorySlice.actions;

// Selectors
export const selectSearchHistoryItems = (state) => state.searchHistory?.items || [];
export const selectSearchHistoryLoading = (state) => state.searchHistory?.loading || false;
export const selectSearchHistoryError = (state) => state.searchHistory?.error || null;

export default searchHistorySlice.reducer;
